<!-- 选择学员在班情况 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="classStudentStatus" placeholder="请选择" multiple clearable
     collapse-tags-tooltip fit-input-width :collapse-tags="true" :max-collapse-tags="1">
        <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in statusOptionList"></el-option>
      </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-学员在班情况',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '学员：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const statusOptionList = ref([{ id: 1, name: '未入班' }, { id: 2, name: '已入班' }]);
    const classStudentStatus = useQuery('classStudentStatus', props.value);
    return {
      classStudentStatus,
      statusOptionList,
    };
  },
};
</script>
